import { Action } from '@ngrx/store';
// TODO : remove @angular/material dependency
import { MatSnackBarConfig } from '@angular/material';

export enum NotificationActionTypes {
  ShowErrorMessage = '[Notification] Show Error Message',
  ShowWarningMessage = '[Notification] Show Warning Message',
  ShowInfoMessage = '[Notification] Show Info Message',
  ShowMessage = '[Notification] Show Message',
  ShowTraceableMessage = '[Notification] Show Traceable Message',
  OnMessageAction = '[Notification] On Message Action',
  AfterMessageDismissed = '[Notification] After Message Dismissed'
}

export class AfterMessageDismissed implements Action {
  readonly type = NotificationActionTypes.AfterMessageDismissed;

  constructor(public tracer: string) {}
}

export class OnMessageAction implements Action {
  readonly type = NotificationActionTypes.OnMessageAction;

  constructor(public tracer: string) {}
}

export class ShowTraceableMessage implements Action {
  readonly type = NotificationActionTypes.ShowTraceableMessage;

  constructor(
    public message: string,
    public tracer: string,
    public action?: string,
    public config?: MatSnackBarConfig
  ) {}
}

export class ShowMessage implements Action {
  readonly type = NotificationActionTypes.ShowMessage;

  constructor(
    public message: string,
    public action?: string,
    public config?: MatSnackBarConfig
  ) {}
}

export class ShowErrorMessage<E = any> implements Action {
  readonly type = NotificationActionTypes.ShowErrorMessage;

  constructor(public message: string, public error?: E, public link?: string) {}
}

export class ShowWarningMessage implements Action {
  readonly type = NotificationActionTypes.ShowWarningMessage;

  constructor(public message: string) {}
}

export class ShowInfoMessage implements Action {
  readonly type = NotificationActionTypes.ShowInfoMessage;

  constructor(public message: string) {}
}

export type NotificationActions =
  | ShowErrorMessage
  | ShowWarningMessage
  | ShowInfoMessage
  | ShowMessage
  | AfterMessageDismissed
  | OnMessageAction
  | ShowTraceableMessage;
